<h5>Capability</h5>
<ul>
  <li *ngFor="let item of capabilityFilter">
    <app-link [ngClass]="{'active': activeFilter == item.name}" (click)="setActive(item.name);">
      {{ item.name }} <span *ngIf="showCounts" >({{ item.count }})</span>
    </app-link>
  </li>
</ul>